// 클립보드 복사 (보안 컨텍스트 폴백 포함).
// Clipboard API(navigator.clipboard)는 보안 컨텍스트(HTTPS 또는 localhost)에서만 존재한다.
// http://local-studio.virtupet.tv 처럼 HTTP + non-localhost 로 서빙되면 undefined 이므로
// 레거시 execCommand("copy") 로 폴백한다.
//
// 폴백은 textarea.focus()+select() 가 아니라 <span> 위의 Range/Selection 을 쓴다.
// execCommand("copy") 는 "윈도우 선택"을 복사하므로 폼 필드 포커스가 필요 없고,
// Vuetify v-dialog 의 포커스 트랩이 포커스를 버튼으로 도로 끌어가도 텍스트 선택은
// 풀리지 않아 다이얼로그 안에서도 정상 복사된다. (textarea 방식은 포커스가
// 트랩에 뺏기면 빈 값이 복사됐다.)
export default async function copyToClipboard(text) {
  const value = String(text);

  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(value);
      return true;
    } catch (e) {
      // 폴백으로 진행
    }
  }

  const span = document.createElement("span");
  span.textContent = value;
  span.style.position = "fixed";
  span.style.top = "0";
  span.style.left = "0";
  span.style.opacity = "0";
  span.style.whiteSpace = "pre"; // 공백/개행 보존
  span.style.userSelect = "text";

  const sel = window.getSelection();
  let savedRange = null;
  if (sel && sel.rangeCount > 0) savedRange = sel.getRangeAt(0).cloneRange();

  let ok = false;
  try {
    document.body.appendChild(span);

    const range = document.createRange();
    range.selectNodeContents(span);
    sel.removeAllRanges();
    sel.addRange(range);

    ok = document.execCommand("copy");
  } catch (e) {
    ok = false;
  } finally {
    if (sel) {
      sel.removeAllRanges();
      if (savedRange) sel.addRange(savedRange); // 기존 사용자 선택 복원
    }
    span.remove();
  }

  return ok;
}
